<template>
  <section>
    <b-table
      :loading="loading"
      :striped="isStriped"
      :hoverable="hoverable"
      default-sort="score"
      default-sort-direction="desc"
      :data="data"
    >
      <template slot-scope="props">
        <!-- <b-table-column label="" field="">
          <b-tooltip :label="props.row.old_rider == true ? 'Jinete antiguo' : 'Jinete Actual' " position="is-right">
            <b-icon icon="account-arrow-left" type="is-danger" v-if="props.row.old_rider"/>
            <b-icon  icon="account-check" type="is-success" v-else/>
          </b-tooltip>
        </b-table-column> -->
        <b-table-column label="Binomio" field="name">
          <link-to-detail type="rider" :resource-id="props.row.rider_id"> {{`${props.row.rider_lastname} ${props.row.rider_name}`}} </link-to-detail>
          <link-to-detail type="horse" :resource-id="props.row.horse_id"> {{`${props.row.horse_name}`}} </link-to-detail>
        </b-table-column>
        <b-table-column label="Edad" field="age" centered>
          {{ props.row.horse_age ? `${props.row.horse_age.years} - ${props.row.horse_age.months}`: 'Sin Información'}}
        </b-table-column>
        <b-table-column label="Nivel Actual" field="start_at" centered >
          <lesson-pdf-button :type="props.row.status" v-if="props.row.status" :lesson-id="props.row.current_lesson_id" :text="props.row.current_lesson_name"/>
          <lesson-pdf-button  v-else :lesson-id="props.row.current_lesson_id" :text="props.row.current_lesson_name"/>
        </b-table-column>
        <b-table-column label="Frecuencia" field="frecuencia" centered>
          {{ props.row.frequency}}
        </b-table-column>
        <b-table-column label="Posición" field="id" centered>
          {{ props.row.position}}
        </b-table-column>
        <b-table-column label="Puntaje" field="score" centered>
          <score-tag :score="props.row.score"/>
        </b-table-column>
      </template>

      <section class="section" slot="empty">
        <div class="content has-text-grey has-text-centered">
          <template v-if="loading">
            <p>
              <b-icon icon="dots-horizontal" size="is-large" />
            </p>
            <p>Cargando Resultados...</p>
          </template>
          <template v-else>
            <p>
              <b-icon icon="horseshoe" size="is-large" />
            </p>
            <p>No hay Resultados&hellip;</p>
          </template>
        </div>
      </section>
    </b-table>
  </section>
</template>

<script>
import ScoreTag from '@/components/ScoreTag.vue'
import LinkToDetail from '@/components/LinkToDetail'
import LessonPdfButton from '@/components/LessonPDFButton'

export default {
  components: {
    ScoreTag,
    LinkToDetail,
    LessonPdfButton
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data () {
    return {
      rankingPositions: [],
      paginated: true,
      perPage: 5,
      isStriped: true,
      isNarrowed: false,
      hoverable: true,
      isFocusable: false,
      isLoading: false,
      hasMobileCards: true
    }
  },
  methods: {
    sortByDate (a, b, isAsc) {
      if (isAsc) {
        return (
          new Date(b.start_date).getDate() - new Date(a.start_date).getDate()
        )
      } else {
        return (
          new Date(a.start_date).getDate() - new Date(b.start_date).getDate()
        )
      }
    }
  }
}
</script>
